var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "open-account" },
    [
      _c(
        "v-row",
        { attrs: { variant: "flex" } },
        [
          _c("v-column", { attrs: { large: 12 } }, [
            _c(
              "div",
              { staticClass: "open-account__inner" },
              [
                !_vm.isSend
                  ? [
                      _c("v-typo", {
                        staticClass: "open-account__headline",
                        attrs: { variant: "h2" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("success.headline"))
                        }
                      }),
                      _vm._v(" "),
                      _c("v-typo", {
                        staticClass: "open-account__perex",
                        attrs: { variant: "body-perex" },
                        domProps: { innerHTML: _vm._s(_vm.$t("success.perex")) }
                      })
                    ]
                  : [
                      _c("v-typo", {
                        staticClass: "open-account__headline",
                        attrs: { variant: "h2" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("openAccount.headline"))
                        }
                      }),
                      _vm._v(" "),
                      _c("v-phone-select", {
                        staticClass: "open-account__form",
                        on: {
                          send: function($event) {
                            _vm.isSend = true
                          }
                        }
                      })
                    ]
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }